export default __webpack_public_path__ + "static/media/1.49e659fd.jpg";